<template>
    <v-container fluid class="container-full-bg-gray">
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="5000">
            {{ snackbar.text }}
        </v-snackbar>
        <v-tabs
            v-model="tab"
            bg-color="primary"
            >
            <v-tab value="workflows">Workflows</v-tab>
            <v-tab value="tests">Tests</v-tab>
        </v-tabs>
        <app-row v-if="workflow_list_component && tab == 0">
            <app-col cols="12">
                <v-card width="100%" class="rounded-xl pt-0 px-0">
                    <v-card-title class="primary--text text--darken-2 px-5 pb-0 d-flex card-title-footer-color">
                        <v-row class="pa-0 ma-0">
                            <v-col cols="3" class="pa-0 ma-0">
                                <span class="primary_blue--text">Workflows</span>
                            </v-col>
                            <v-col cols="9" class="pa-0 ma-0">
                                <slot name="search_right">
                                    <div align="right" class="actions">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="refreshList()" color="primary" icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Actualizar</span>
                                        </v-tooltip>         
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="newWfTemplate()" color="primary" icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Nuevo Workflow</span>
                                        </v-tooltip>                               
                                    </div>
                                </slot>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="px-0 pt-0 card-title-footer-color">
                        <v-data-table
                            v-model="screen_data.selectedItems" 
                            :items="screen_data.templates"
                            :headers="screen_data.template_headers"
                            :show-select="screen_data.showSelect"
                            :loading="screen_data.loadingItems"
                            :no-data-text="screen_data.textNoResults" 
                            :loading-text="screen_data.textLoading" 
                            @toggle-select-all="" 
                            @update:sort-by="sortTable"
                            @update:sort-desc="sortTableDesc"
                            :items-per-page="100"
                            hide-default-footer
                            fixed-header
                            :item-key="screen_data.itemKey" 
                            :mobile="screen_data.mobile" 
                            @click:row="selectRow">
                            <template v-for="header in screen_data.template_headers" v-slot:[`item.${header.value}`]="{ item }">

                                <template v-if="header.value === 'type'">
                                    <span v-if="[null,undefined,''].includes(item.input_entity_type_uuid)">Documento</span>
                                    <span v-else>Params</span>
                                </template>
                                <template v-else>
                                    <slot :name="header.value" v-bind="item">{{ item[header.value] }}</slot>
                                </template>
                            </template>
                            
                        </v-data-table>
                    </v-card-text>
                               
                </v-card>
            </app-col>
        </app-row>

        <app-row v-else-if="workflow_list_component && tab == 1">
            <app-col cols="12">
                <v-card width="100%" class="rounded-xl pt-0 px-0">
                    <v-card-title class="primary--text text--darken-2 px-5 pb-0 d-flex card-title-footer-color">
                        <v-row class="pa-0 ma-0">
                            <v-col cols="3" class="pa-0 ma-0">
                                <span class="primary_blue--text">Tests</span>
                            </v-col>
                            <v-col cols="9" class="pa-0 ma-0">
                                <slot name="search_right">
                                    <div align="right" class="actions">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="refreshTestsList()" color="primary" icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Actualizar</span>
                                        </v-tooltip>         
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="newWfTest()" color="primary" icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Nuevo Test</span>
                                        </v-tooltip>                               
                                    </div>
                                </slot>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="px-0 pt-0 card-title-footer-color">
                        <v-data-table
                            v-model="screen_data.selectedItems" 
                            :items="screen_data.tests"
                            :headers="screen_data.test_headers"
                            :show-select="screen_data.showSelect"
                            :loading="screen_data.loadingItems"
                            :no-data-text="screen_data.textNoResults" 
                            :loading-text="screen_data.textLoading" 
                            @toggle-select-all="" 
                            @update:sort-by="sortTable"
                            @update:sort-desc="sortTableDesc"
                            :items-per-page="100"
                            hide-default-footer
                            fixed-header
                            :item-key="screen_data.itemKey" 
                            :mobile="screen_data.mobile" 
                            @click:row="testPopUp">
                            <!-- Columnas Personalizables -->
                            <template v-for="header in screen_data.test_headers" v-slot:[`item.${header.value}`]="{ item }">
                                
                                <template v-if="header.value === 'passed'">
                                    <v-icon v-if="item.passed === true" color="green">mdi-check-circle</v-icon>
                                    <v-icon v-else-if="item.passed === false" color="red">mdi-close-circle</v-icon>
                                    <span v-else>-</span> <!-- For undefined/null -->
                                </template>
                                <template v-else-if="header.value === 'workflow_template_id'">
                                    <span>{{ wf_name_map[item[header.value]] }}</span>
                                </template>
                                <template v-else-if="header.value === 'run'">
                                    <v-btn
                                        color="primary"
                                        icon
                                        :loading ="item.state === 'running'"
                                        @click.stop="runTest(item)"
                                        :disabled="item.state === 'running'">
                                        <v-icon>mdi-play</v-icon>
                                    </v-btn>
                                </template>
                                <template v-else>
                                    <slot :name="header.value" v-bind="item">{{ item[header.value] }}</slot>
                                </template>

                            </template>
                            <!--Footer: Paginación-->
                            <!-- <template v-slot:[`footer.page-text`]="items">
                                {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                            </template> -->
                        </v-data-table>
                    </v-card-text>
                               
                </v-card>
            </app-col>
        </app-row>
        <v-dialog v-if="screen_data.detail_test_pop_up" v-model="screen_data.detail_test_pop_up" max-width="900px">
            <v-card>
                <WorkflowTestEditor v-model ="screen_data.selected_test"
                                    @submit="submitted"
                                    @copy-output="copyOutputToClipboard"
                                    @download-output="downloadOutputAsFile"
                                    :loading="screen_data.loading_test"
                                    :workflow_options="params_wf_templates"
                                    :company_options="get_companydbs"/>
            </v-card>
        </v-dialog>

    </v-container>
    
</template>
  
<script>
import AppBtn from "@/components/layout/AppBtn.vue";
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import { ApiWorkflowTemplateRepository } from "@/modules/document/infra/ApiWorkflowTemplateRepository";
import { ApiWorkflowTestRepository } from "@/modules/document/infra/ApiWorkflowTestRepository";
import { WorkflowTemplateListComponent } from "@/modules/document/application/WorkflowTemplateListComponent";
import { WorkflowTemplateListScreenData } from "@/modules/document/domain/WorkflowTemplateListScreenData";
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import WorkflowTestEditor from '@/modules/document/infra/WorkflowTestEditor.vue'
import { mapGetters } from "vuex";
import { copy_to_clipboard, download_json_as_file } from "@/modules/shared/infra/ClipboardUtils";

export default {
    name: "WorkflowList",
    components: {
        AppBtn,
        AppCol,
        AppRow,
        WorkflowTestEditor
    },
    data() {
        const screen_data = new WorkflowTemplateListScreenData();
        return {
            screen_data: screen_data,
            workflow_list_component: null,
            tab: null,
            snackbar: {
                show: false,
                text: '',
                color: 'success'
            }
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
            default: null
        }
    },
    computed:{
        ...mapGetters([
            'get_companydbs', //fa mal pero ara fer una query de empreses no em va de pas
            ]),
        
        wf_name_map() {
            return this.screen_data.templates.reduce((acc, template) => {
                acc[template.id] = template.name;
                return acc;
            }, {});
        },
        params_wf_templates() {
            return this.screen_data.templates.filter(template => ![null, undefined, ''].includes(template.input_entity_type_uuid));
        },
    },
    methods: {
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        selectRow(item) {
            this.$router.push({ 'name': "workflow-editor", 'params': {'workflow_id': item.id }})
        },
        testPopUp(item){
            this.screen_data.selected_test = item;
            this.screen_data.detail_test_pop_up = true;
        },
        sortTable(value){
            if (value.length){
                this.screen_data.sort_by = value[0]
                this.workflow_list_component.refreshList(this.companydb_id)
            }
            else{
                this.screen_data.sort_by = ''
                this.workflow_list_component.refreshList(this.companydb_id)
            }
        },
        sortTableDesc(value){
            if (value.length && value[0]){
                this.screen_data.sort_by = '-'+this.screen_data.sort_by
                this.workflow_list_component.refreshList(this.companydb_id)
            }
        },
        newWfTemplate(){
            this.$router.push({ 'name': "workflow-editor", 'params': {'workflow_id': null }})
        },
        async refreshList(){
            this.workflow_list_component.refreshList(this.companydb_id)
        },
        newWfTest(){
            this.workflow_list_component.new_workflow_test();
        },
        async submitted(){
            const result = await this.workflow_list_component.saveSelectedTest()
            if (!result.success) {
                this.snackbar = { show: true, text: result.error || 'Error al guardar', color: 'error' }
            }
        },
        async refreshTestsList(){
            this.workflow_list_component.refreshTestsList();
        },
        async runTest(item){
            await this.workflow_list_component.runTest(item);
        },
        changeLimit(value){
            this.screen_data.limit = value
            this.workflow_list_component.refreshList(this.companydb_id)
        },
        changeOffset(value){
            this.screen_data.offset = (value-1)*this.screen_data.limit
            this.workflow_list_component.refreshList(this.companydb_id)
        },
        onTabChange(newVal){
            if (newVal == 0){
                this.workflow_list_component.refreshList(this.companydb_id);
            } else if (newVal == 1) {
                this.workflow_list_component.refreshTestsList();
            }
        },
        copyOutputToClipboard(output) {
            copy_to_clipboard(output);
        },
        downloadOutputAsFile(output) {
            const testName = this.screen_data.selected_test.name || 'workflow_test';
            const filename = `${testName}_output.json`;
            download_json_as_file(output, filename);
        }
    },
    async mounted() {
        this.workflow_list_component = new WorkflowTemplateListComponent(new ApiWorkflowTemplateRepository(), new ApiWorkflowTestRepository(),this.screen_data, this.companydb_id);
        this.refreshList();
    },
    watch: {
        tab(newVal) {
        this.onTabChange(newVal);
        }
    },
  
};
</script>

<style scoped>
::v-deep .v-card__title {
    padding-top: 15px !important;
    padding-bottom: 15px !important;

}
.card-title-footer-color {
    background: #fafaff;
}

::v-deep .v-data-footer {
    background-color: #fafaff;
    margin-right: 0px !important;
    padding-right: 17px;
}

::v-deep .v-data-table-header>tr>th {
    background-color: var(--v-primaryLight-base) !important;
}

::v-deep .v-data-table-header>tr>th>span,
::v-deep .v-data-table-header>tr>th>div>div>div>label>span {
    color: var(--v-primary-base);
    font-size: 0.875rem;
}

.font-color {
    color: #56565b;
}

::v-deep .v-data-table__wrapper>table>tbody>tr>td {
    border-bottom: none !important;
}

::v-deep tbody tr:nth-of-type(even) {
    /* 'deep-orange lighten-5' basides on material design color */
    background-color: rgba(245, 245, 245, 0.47);
}

::v-deep .v-input__prepend-inner>div>i {
    color: var(--v-primary-base);
    top: 2px;
    padding-left: 5px;
}

.text-field-size {
    font-weight: normal;
    font-size: 0.875rem;
}

::v-deep .input-search .v-input__slot::before {
    border-style: none !important;
}

::v-deep .input-search .v-text-field__slot,
::v-deep .input-search .v-input__prepend-inner,
::v-deep .input-search .v-input__slot {
    background-color: #f2f1ff !important;
}

::v-card-title .title-dialog {
    justify-content: space-around;
}
</style>
  